import { BillPay, policyDocs } from '@/common/CanceledPolicy';
import Global from './Global';

const Routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "UMIA" */ '@/pages/Home/Home.vue'),
		meta: {
			title: 'Home',
			auth: true,
		},
	},
	{
		path: '/coi/:policy_number?',
		name: 'coi',
		component: () =>
			import(/* webpackChunkName: "UMIA" */ '@/pages/Policy/Umia/UmiaPolicy.vue'),
		meta: {
			title: 'Certificate of Insurance',
			auth: true,
			canceledPolicies: policyDocs,
		},
	},
	{
		path: '/claims/submit',
		name: 'submitclaim',
		component: () =>
			import(/* webpackChunkName: "UMIA" */ '@/pages/Claims/Umia/SubmitClaim.vue'),
		meta: {
			title: 'Submit Claim',
			auth: true,
		},
	},
	{
		path: '/claims',
		name: 'claims',
		component: () => import(/* webpackChunkName: "UMIA" */ '@/pages/Claims/Umia/Claims.vue'),
		meta: {
			title: 'Claims',
			auth: true,
		},
	},
	{
		path: '/claims/thankyou',
		name: 'claimThankYou',
		component: () =>
			import(/* webpackChunkName: "UMIA" */ '@/pages/Claims/Umia/ThankYouSubmission.vue'),
		meta: {
			title: 'Claim Submission - Thank You',
			auth: true,
		},
	},
	{
		path: '/payment',
		name: 'payment',
		component: () => import(/* webpackChunkName: "UMIA" */ '@/pages/BillPay/PayBill.vue'),
		meta: {
			title: 'Pay My Bill',
			auth: true,
			canceledPolicies: BillPay,
		},
	},
	{
		path: '/payment/methods',
		name: 'paymentmethods',
		component: () =>
			import(/* webpackChunkName: "UMIA" */ '@/pages/BillPay/PaymentMethods.vue'),
		meta: {
			title: 'Payment Methods',
			auth: true,
			canceledPolicies: BillPay,
		},
	},
	// {
	//      path: '/payment/reoccuring',
	//      name: 'paymentreoccuring',
	//      component: () =>
	//           import(/* webpackChunkName: "UMIA" */ '@/pages/BillPay/Global/Reoccuring.vue'),
	//      meta: {
	//           title: 'Reccuring Payments',
	//           auth: true,
	//      },
	// },
	{
		path: '/page/*',
		name: 'pages',
		component: () => import(/* webpackChunkName: "UMIA" */ '@/pages/Pages/Page.vue'),
		meta: {
			title: '',
			auth: true,
		},
	},
	{
		path: '/organization/invite',
		name: 'org_invites',
		component: () =>
			import(/* webpackChunkName: "UMIA" */ '@/pages/Organization/InviteUsers.vue'),
		meta: {
			title: 'Admin',
			auth: true,
		},
	},
	{
		path: '/organization/manage',
		name: 'org_managerisks',
		component: () =>
			import(/* webpackChunkName: "UMIA" */ '@/pages/Organization/ManageUsers.vue'),
		meta: {
			title: 'Admin',
			auth: true,
		},
	},
	{
		path: '/organization/manage/:subId',
		name: 'org_managerisk',
		component: () =>
			import(/* webpackChunkName: "UMIA" */ '@/pages/Organization/ManageUser.vue'),
		meta: {
			title: 'Admin',
			auth: true,
		},
	},
	{
		path: '/credential-reports',
		name: 'credential-reports',
		component: () =>
			import(/* webpackChunkName: "MMIC" */ '@/pages/Reports/CredentialingReports.vue'),
		meta: {
			title: 'Credentialing Reports',
			auth: true,
			canceledPolicies: policyDocs,
		},
	},
	{
		path: '/loss-history',
		name: 'loss-history',
		component: () =>
			import(/* webpackChunkName: "MMIC" */ '@/pages/Reports/LossHistoryReports.vue'),
		meta: {
			title: 'Loss History Reports',
			auth: true,
			canceledPolicies: policyDocs,
		},
	},
	{
		path: '/reports-access-warning',
		name: 'reports-access',
		component: () =>
			import(/* webpackChunkName: "MMIC" */ '@/pages/Reports/ReportsAccessWarning.vue'),
		meta: {
			title: 'Reports Access Message',
			auth: true,
			canceledPolicies: policyDocs,
		},
	},
	...Global,
];

export default Routes;
